export { default } from './ScrollToNext';


// WEBPACK FOOTER //
// ./src/components/ScrollToNext/index.js